/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { csmeConfig } from '../../config/csme.config';
import { carricomConfig } from '../../config/carricom.config';
import { acknowledgementConfig } from '../../config/acknowledgement.config';
import { headerConfig } from '../../config/header.config';
import { header2Config } from '../../config/header2.config';
import { loadingConfig } from '../../config/loading.config';
import { errorConfig } from '../../config/error.config';
import { newUserConfig } from '../../config/newUser.config';
import { marriageConfig } from '../../config/marriage.config';
import { notificationConfig } from '../../config/notifications.config';
import { rightFaqConfig } from '../../config/right-faq-block.config';
import { workPermitConfig } from '../../config/workPermit.config';
import { csmeVerificationConfig } from '../../config/csmeVerification.config';
import { renewWorkPermitFormData } from '../../config/renewWorkPermit.config';
import { renewCsmeConfig } from '../../config/renewCsme.config';
import { rightEstablishmentConfig } from '../../config/rightEstablishment.config';
import { MarriageExemptiConfig } from '../../config/marriageExemption.config';
import { resubmitConfig } from '../../config/resubmit.config';
import { applicationCardConfig } from '../../config/applicationCards.config';
import { roeworkPermitConfig } from '../../config/roeWorkpermit.config';
export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

// const getBreadcrumbService = () => {
//   const app = VApplication.getInstance();
//   return app.getSync("services.BreadcrumbService") as BreadcrumbService;
// };

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    // const srv = getBreadcrumbService();
    // const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      header: { ...headerConfig },
      header2: { ...header2Config },
      loading: loadingConfig,
      error: errorConfig,
      acknowledgement: acknowledgementConfig,
      newUser: newUserConfig,
      notifications: notificationConfig,
      workPermitFormData: workPermitConfig,
      csmeFormData: csmeConfig,
      carricomFormData: carricomConfig,
      renewCsmeFormData: renewCsmeConfig,
      renewWorkPermitFormData: renewWorkPermitFormData,
      rightEstablishmentContent: rightEstablishmentConfig,
      marriageFormData: marriageConfig,
      rightBlockContent: rightFaqConfig,
      marriageExemptionFormData: MarriageExemptiConfig,
      csmeVerificationFormData: csmeVerificationConfig,
      resubmitFormData: resubmitConfig,
      applicationCards: applicationCardConfig,
      roeworkPermitFormData: roeworkPermitConfig,
      // carricomRightFormData:carricomRightFormData
    };
  }
}
